import "./style.css";
import { Box, Grid, InputLabel } from "@mui/material";
import { FC, Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import { customizeOtpValidationSchema } from "./variable/customSchema";
import { getOtpDataFields } from "../variable/textField";
import { NavLink } from "react-router-dom";
import useMutation from "../../../../../shared/components/hooks/useMutation";

type OtpFormProps = {
  setVerficationStatus: Function;
  twoFactorAuthFlag: boolean;
  fetchData: Function;
  userEmail: string;
};
const OtpForm: FC<OtpFormProps> = ({
  setVerficationStatus,
  twoFactorAuthFlag,
  fetchData,
  userEmail,
}) => {
  const [timer, setTimer] = useState({ minutes: 2, seconds: 0 });
  const { loading: apiLoading, modifyData } = useMutation();
  useEffect(() => {
    // Start a timer
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer.seconds > 0) {
          return { ...prevTimer, seconds: prevTimer.seconds - 1 };
        } else if (prevTimer.minutes > 0) {
          return { minutes: prevTimer.minutes - 1, seconds: 59 };
        } else {
          clearInterval(interval);
          return prevTimer;
        }
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer.minutes, timer.seconds]);

  const textFields = getOtpDataFields({}); //Get textboxes
  const initialValues = {
    otp: "",
    twoFactorAuthFlag: twoFactorAuthFlag,
  };

  const otpForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeOtpValidationSchema(),
    onSubmit: async (formData: any) => {
      let response = await modifyData(
        `admin/two-factor-auth/verify-otp`,
        "post",
        {
          ...formData,
        },
        otpForm
      );
      if (response) {
        setVerficationStatus(false);
        fetchData();
      }
    },
  });

  const titleBar = {
    headerTitle: "",
    title: "Verify OTP",
    buttonTitle: " Verify OTP",
    onClick: () => otpForm.handleSubmit(),
    dirty: otpForm.dirty,
    buttonLoading: apiLoading,
  };
  const resendOtp = async () => {
    await modifyData(`admin/two-factor-auth/generateDisableOtp`, "put");
    setTimer({ minutes: 2, seconds: 0 });
  };

  const maskEmail = (email: string): string => {
    const [localPart, domain] = email.split("@"); // Split email into local part and domain
    if (localPart.length <= 2) {
      return `${localPart.charAt(0)}***@${domain.charAt(0)}***.${domain
        .split(".")
        .pop()}`;
    }
    return `${localPart.charAt(0)}****${localPart.charAt(
      localPart.length - 1
    )}@${domain.charAt(0)}***.${domain.split(".").pop()}`;
  };
  return (
    <>
      <FormContainer titleBar={titleBar}>
        <Box className="border-custom">
          <Grid container alignItems="stretch" columnSpacing={4} rowSpacing={2}>
            <Grid item md={12} sm={6} xs={12}>
              Enter the Authentication code sent to {maskEmail(userEmail)}
            </Grid>
            {textFields.map((field: any, index: number) => (
              <Fragment key={field.id}>
                {(field?.formField === undefined ||
                  field.formField === true) && (
                  <Grid item md={6} sm={6} xs={12}>
                    <InputTextfield
                      form={otpForm}
                      fieldProps={field}
                      key={index}
                    />
                  </Grid>
                )}
              </Fragment>
            ))}
            <Grid item md={6}></Grid>
            <Grid item md={6}>
              <InputLabel className="otpTimerLabel">
                {timer.seconds > 0 || timer.minutes > 0 ? (
                  `Time Remaining: ${
                    timer.minutes < 10 ? `0${timer.minutes}` : timer.minutes
                  }:${timer.seconds < 10 ? `0${timer.seconds}` : timer.seconds}`
                ) : (
                  <>
                    "Didn't receive code?"{" "}
                    <NavLink to="" onClick={resendOtp} aria-label="Resend Otp">
                      Resend OTP
                    </NavLink>
                  </>
                )}
              </InputLabel>
            </Grid>
          </Grid>
        </Box>
      </FormContainer>
    </>
  );
};
export default OtpForm;
